/** Update the role of an existing tenant member. */
export const tenantUserSaveSpec = {
    uri: '/t/[tenant]/user/[user]',
    method: 'PUT',
};
